import { getClasses } from '@/_utils/classnames';
import { HRMarkup } from '../HRMarkup/HRMarkup';
import styles from './VerticalSeparator.module.css';
import type { FC } from 'react';
import type { SeparatorProps } from '../../../Separator/Separator.types';

const VerticalSeparator: FC<SeparatorProps> = ({
  isLight,
  isInverted,
  height,
  isAccent,
}) => {
  const hrClassNames: string = getClasses(styles.verticalSeparator, {
    [styles.verticalSeparatorRegular]: !isLight,
    [styles.verticalSeparatorLight]: isLight,
    [styles.verticalSeparatorInverted]: isInverted,
    [styles.verticalSeparatorAccent]: isAccent,
  });

  const verticalStyle = {
    height: !!height ? `${height ?? 0}px` : 'auto',
  };

  return <HRMarkup style={verticalStyle} className={hrClassNames} />;
};

export { VerticalSeparator };
